import cloneDeep from 'lodash/cloneDeep'

export default {
  setShowTableau (state, status) {
    state.showTableau = status
  },
  setIsInitialized (state, status) {
    state.isInitialized = status
  },
  setIsUpdating (state, status) {
    state.isUpdating = status
  },
  setTotalSheets (state, status) {
    state.totalSheets = status
  },
  setSheetsInitialized (state, status) {
    state.sheetsInitialized = status
  },
  setParameters (state, parameters) {
    state.parameters = cloneDeep(parameters)
  },
  setParameter (state, pair) {
    state.parameters[pair.key] = pair.value
    state.parameters = cloneDeep(state.parameters)
  },
  updateTableauParameters(state, { name, value }) {
    // Ensure parameters exist and update them
    if (!state.parameters) {
      state.parameters = {}
    }
    // Update or add the parameter directly
    state.parameters[name] = value
  },
  updateVizFilterSelection(state, { name, values, isAllSelected }) {
    state.vizFilters[name] = { values, isAllSelected }
  }
}
